<div class="profile-container">
    <div class="profile-header">
        <h1 class="m-Opener-headline">
            {{ configData.header | translate }}
        </h1>
    </div>
    <div class="profile-content">
        <div *ngFor="let item of profileData" class="profile-row">
            <div class="profile-label">
                <b>{{item.label}}</b>
            </div>
            <div class="profile-value">
                <div *ngIf="item.label === 'Units of Measurements (UoM)' && preferredUOM !== 'null'" class="custom-radio-group">
                    <label *ngFor="let option of item.radioOptions" class="custom-radio-button">
                        <input type="radio" [value]="option" [checked]="item.value === option" name="UoM" (click)="onRadioChnage($event)">
                        <span>{{option}}</span>
                    </label>
                </div>
                <div *ngIf="item.label !== 'Units of Measurements (UoM)'">
                    {{item.value}}
                </div>
            </div>
        </div>
    </div>
</div>
